import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("icon-value " + _vm.color + "--text")},[_c(VIcon,{attrs:{"left":"","color":_vm.color,"disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.value)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }